import { render, staticRenderFns } from "./UserSingle.vue?vue&type=template&id=a3aa5bbe&"
import script from "./UserSingle.vue?vue&type=script&lang=js&"
export * from "./UserSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSingle.vue"
export default component.exports